import { Selector } from '@ngxs/store';
import { TransactionsStateModel } from './transactions.models';
import { TransactionsState } from './transactions.state';
import { AccountingSyncStatus } from '../../_interfaces/accounting.interface';

export class TransactionsSelectors {
  @Selector([TransactionsState])
  static transactionSyncStatus(state: TransactionsStateModel): AccountingSyncStatus | null {
    return state.transactionSyncStatus;
  }

  @Selector([TransactionsState])
  static contactsSyncStatus(state: TransactionsStateModel): AccountingSyncStatus | null {
    return state.contactsSyncStatus;
  }

  @Selector([TransactionsState])
  static categoriesSyncStatus(state: TransactionsStateModel): AccountingSyncStatus | null {
    return state.categoriesSyncStatus;
  }

  @Selector([TransactionsState])
  static error(state: TransactionsStateModel): boolean {
    return state.error;
  }

  @Selector([TransactionsState])
  static busySyncing(state: TransactionsStateModel): boolean {
    return state.busySyncing;
  }
}
